import { useState, useRef } from 'react';
import { CircularProgress, ButtonGroup, ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList } from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Button } from "@gisce/oficina-virtual-components";
import { GetApp } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useInvoicesDetail } from '../hooks/useInvoiceDetail';
import { ErpFeatureKeys } from '@/components/ErpFeatures/models/erpFeature';
import { useFeatureEnabled } from '@/components/ErpFeatures/hooks/useErpFeatures';

export const DownloadButton = ({ invoiceId, type, options, historic }) => {
  const downloadStatus = useSelector((state) => state.invoices[type].download_status[invoiceId]);
  const { t } = useTranslation();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('pdf');
  const { handleDownload } = useInvoicesDetail({invoiceId});

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const handleClickDownload = (option, historic) => {
    setSelectedOption(option);
    handleDownload({type, option: options[option]['type'], historic});
    setOpen(false);
  }
  
  const isHistoricEnabled = useFeatureEnabled(ErpFeatureKeys.FEATURE_HISTORIC_INVOICES_ENDPOINT);
  return !historic || isHistoricEnabled ?
    <>
      <ButtonGroup
        variant='contained'
        ref={anchorRef}
        aria-label='Button group with a nested menu'
        disabled={downloadStatus}
      >
        <Button 
          title={"Download invoice"}
          color={'primary'}
          variant={'contained'}
          onClick={() => handleClickDownload('pdf', historic)}
          sx={{
            minWidth: Object.keys(options).length > 1 ? '100px' : '110px',
            maxWidth: Object.keys(options).length > 1 ? '260px' : '270px',
            fontSize: '12px'
          }}
        >
          {downloadStatus ? <CircularProgress size={20} sx={{marginRight: '5px'}} /> : <GetApp />}
          {downloadStatus ? options[selectedOption]['name'] : t('common:text.invoices_view_download_button')}
        </Button>
        { Object.keys(options).length > 1 &&
          <Button
            size='small'
            aria-controls={open ? 'split-button-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-label='select download option'
            aria-haspopup='menu'
            onClick={() => setOpen((prevOpen) => !prevOpen)}
            color='primary'
          >
            <ArrowDropDownIcon />
          </Button>
        }
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 1,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id='split-button-menu' autoFocusItem>
                  {Object.keys(options).map((option) => (
                    option != 'pdf' && (
                      <MenuItem
                        key={option}
                        onClick={(event) => handleClickDownload(option, historic)}
                      >
                        {options[option]['name']}
                      </MenuItem>
                    )
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
    :
    <> </>
};
